<template>
  <div class="mk-autoweb-image-block">
    <div class="w1200 animate_top index-changjing-box">
      <div class="subject-component-title center">{{ element.titleBarName }}</div>
      <ul>
        <li
          :key="index"
          v-for="(item, index) in childItem.propsValue.data[0].customField11"
          :class="className()"
        >
          <img class="image-block-img" :src="item.customField1" />
          <div class="image-block-text">{{ item.customField2 }}</div>
          <div class="image-block-info">
            <p class="image-block-info-title">{{ item.customField2 }}</p>
            <p class="image-block-info-desc">{{ item.customField3 }}</p>
            <p class="image-block-info-btn">
              <a>{{ item.customField4.text}}</a>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "../../../../../config/elementObject.js";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "MkImageBlockWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField10",
          label: "组名",
          type: "text"
        },
        {
          code: "customField11",
          label: "集合",
          type: "list",
          children: [
            {
              code: "customField1",
              label: "logo",
              type: "image",
              width: 280,
              height: 170
            },
            {
              code: "customField2",
              label: "标题",
              type: "text"
            },
            {
              code: "customField3",
              label: "描述",
              type: "text"
            },
            {
              code: "customField4",
              label: "按钮",
              type: "button"
            }
          ]
        }
      ],
      data: [
        {
          customField10: "",
          customField11: [
            {
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: _.cloneDeep(buttonObject)
            }
          ]
        },
        {
          customField10: "",
          customField11: [
            {
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: _.cloneDeep(buttonObject)
            }
          ]
        },
        {
          customField10: "",
          customField11: [
            {
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: _.cloneDeep(buttonObject)
            }
          ]
        },
        {
          customField10: "",
          customField11: [
            {
              customField1: "",
              customField2: "",
              customField3: "",
              customField4: _.cloneDeep(buttonObject)
            }
          ]
        }
      ]
      // 第一版本对象
      // fields: [
      //   {
      //     code: "customField1",
      //     label: "logo",
      //     type: "image",
      //     width: 280,
      //     height: 170
      //   },
      //   {
      //     code: "customField2",
      //     label: "标题",
      //     type: "text"
      //   },
      //   {
      //     code: "customField3",
      //     label: "描述",
      //     type: "text"
      //   },
      //   {
      //     code: "customField4",
      //     label: "按钮",
      //     type: "button"
      //   }
      // ],
      // data: [
      //   {
      //     customField1:
      //       "https://mks.yybip.com/group1/M00/09/92/CgoRC2Rcf2eARgBnAAHQcTcz9Ng332.png",
      //     customField2: "财务管理",
      //     customField3:
      //       "财务共享、财资管理、全面预算财务共享、财资管理、全面预算",
      //     customField4: {
      //       afterClick: {
      //         contentId: "",
      //         contentImage: "",
      //         contentName: "",
      //         contentType: "data",
      //         type: 1,
      //         url: ""
      //       },
      //       beforeClick: {
      //         form: "",
      //         formtime: "一天",
      //         type: 0
      //       },
      //       text: "了解详情"
      //     }
      //   }
      // ]
    };
  },
  methods: {
    className() {
      let elementClass = "";
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      if (selectClass) {
        elementClass = selectClass.value;
      }
      return elementClass;
    },
    ...mapMutations(["setProjectData"]),
    // 升级组件属性方法
    updatePropsValue() {
      let updateFlag = false;
      this.projectData.elements = _.map(this.projectData.elements, el => {
        // 找到落地页当前组件
        if (el.uuid == this.element.uuid) {
          updateFlag = true;
          el.childNode = _.map(el.childNode, child => {
            let childDataTemp = _.cloneDeep(child.propsValue.data);
            child.propsValue.fields = this.fields;
            child.propsValue.data = [
              {
                customField10: "",
                customField11: childDataTemp
              }
            ];
            return child;
          });
          return el;
        } else {
          return el;
        }
      });
      updateFlag ? this.setProjectData(this.projectData) : "";
    }
  },
  mounted() {
    // 第一版本对象属性跟第二版本不一样，升级组件属性
    if (
      this.element &&
      this.element.childNode &&
      this.element.childNode.length > 0 &&
      _.filter(
        this.element.childNode[0].propsValue.fields,
        (f, fi) => f.code == "customField10"
      ).length == 0
    ) {
      // this.updatePropsValue();
    }
  },
  computed: {
    ...mapState({
      projectData: state => state.autowebStore.projectData
    })
  }
};
</script>

<style scoped lang="scss">
.mk-autoweb-image-block {
  width: 100%;
  min-height: 365px;
  padding: 0 30px;
}

.index-changjing-box .subject-component-title {
  padding-top: 22px;
  font-size: 22px;
  line-height: 58px;
  color: #e31924;
  text-align: center;
}

.index-changjing-box ul {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.index-changjing-box li {
  padding: 0 16px;
  position: relative;
  width: 21%;
  height: 120px;
  margin: 0 30px 20px 0;
  background-size: 100% 100%;
}
.index-changjing-box li .image-block-img {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
}

.index-changjing-box li .image-block-text {
  text-align: left;
  margin-top: 88px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #ffffff;
}

.index-changjing-box li .image-block-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 88px;
  color: #ffffff;
  margin: 36px 16px 0;
  display: none;
  font-size: 13px;
  font-family: MicrosoftYaHei;
}

.index-changjing-box li .image-block-info .image-block-info-title {
  font-size: 14px;
  color: #ffffff;
}

.index-changjing-box li .image-block-info .image-block-info-desc {
  font-size: 10px;
  line-height: 18px;
  height: 36px;
  color: #ffffff;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.index-changjing-box li .image-block-info .image-block-info-btn {
  font-size: 10px;
  text-align: right;
  text-decoration: underline;
  color: #ffffff;
  a {
    color: #ffffff;
  }
}

.index-changjing-box li:hover {
  cursor: pointer;
}

.index-changjing-box li:hover .image-block-info {
  display: block;
  overflow-y: auto;
}

.index-changjing-box li:hover .image-block-text {
  display: none;
}

.index-changjing-box .mk-autoweb-type {
  margin: 0 10px 20px 10px;
  height: 185px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}
.index-changjing-box .mk-autoweb-type .image-block-img {
  height: 120px;
  width: 100%;
}
.index-changjing-box .mk-autoweb-type .image-block-text {
  display: none;
}
.index-changjing-box .mk-autoweb-type .image-block-info {
  display: block;
  height: 160px;
  padding-top: 30px;
  margin: 20px 12px 0;
}
.index-changjing-box .mk-autoweb-type .image-block-info .image-block-info-desc {
  margin-top: 60px;
  margin-bottom: 10px;
  height: 20px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #333;
}
.index-changjing-box .mk-autoweb-type .image-block-info .image-block-info-btn {
  text-align: left;
}
.index-changjing-box
  .mk-autoweb-type
  .image-block-info
  .image-block-info-btn
  a {
  padding: 3px 5px;
  color: #333;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  border-radius: 2px;
  font-size: 10px;
  text-decoration: none !important;
}
</style>
